import React from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate, useParams } from 'react-router-dom'
import type { State } from 'types/redux'
import { makeGetContact } from '@disco/state-management/selectors/contacts'
import Button from 'components/ui/button'
import DataTable from 'components/ui/data-table'
import ModalWindow from 'components/ui/modal-window'
import { renderPlaylistCell } from 'pages/contacts/contact-details/activity-tab'

const ContactActivity: React.FC = () => {
  const params = useParams<{ contactId: string }>()
  const navigate = useNavigate()
  const getContact = React.useMemo(() => makeGetContact(), [])
  const contact = useSelector((state: State) =>
    getContact(state, {
      contactId: Number(params.contactId),
    }),
  )

  const handleClose = () => {
    navigate(`/contacts/${params.contactId}`)
  }

  return (
    <ModalWindow
      header="Activity"
      isOpen={true}
      actions={<Button caption="Close" onClick={handleClose} />}
      onClose={handleClose}
    >
      <DataTable
        columns={[
          {
            name: 'Name',
            render: (props: Record<string, any>) => (
              <Link to={`/explorer/playlists/${props.id}`}>{props.name}</Link>
            ),
          },
          {
            name: 'Page views',
            width: 'content',
            render: (props: Record<string, any>) =>
              renderPlaylistCell(props as any, 'Page views', 'access_playlist'),
          },
          {
            name: 'Playlist downloads',
            width: 'content',
            render: (props: Record<string, any>) =>
              renderPlaylistCell(
                props as any,
                'Playlist downloads',
                'download_zip',
              ),
          },
          {
            name: 'Track downloads',
            width: 'content',
            render: (props: Record<string, any>) =>
              renderPlaylistCell(
                props as any,
                'Track downloads',
                'download_track',
              ),
          },
          {
            name: 'Streams',
            width: 'content',
            render: (props: Record<string, any>) =>
              renderPlaylistCell(props as any, 'Streams', 'play_track'),
          },
        ]}
        data={contact.activity}
      />
    </ModalWindow>
  )
}

export default ContactActivity
